module.exports = __webpack_public_path__ + "img/微信图片_20211227103556.9fe62686.png";